export const jiminiAlertsConstants = {
  INIT: 'FETCH_JIMINI_ALEERTS_INIT',
  SUCCESS: 'FETCH_JIMINI_ALEERTS_SUCCESS',
  REFRESH: 'FETCH_JIMINI_ALEERTS_REFRESH',
  FAILURE: 'FETCH_JIMINI_ALEERTS_FAILURE',
  CLEAR: 'FETCH_JIMINI_ALEERTS_CLEAR',
}
